import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";
import { UserService } from "../../../service/user.service";

@Component({
    selector: 'kt-dialog-user-geozone',
    templateUrl: './dialog-user-geozone.component.html',
    styleUrls: ['./dialog-user-geozone.component.scss'],
})
export class DialogUserGeoZoneComponent implements OnInit {

    isLoadingResults: boolean = false;
    crmUserEditForm: FormGroup;
    userId : string;
    @ViewChild('inputZone') inputZone: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<DialogUserGeoZoneComponent>,
        private cdr: ChangeDetectorRef,
        private userService: UserService,
        private _snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA)
		    public data: UserGeoZoneData
      ) { }

    ngOnInit(): void {

    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  guardarCambios(){
    if(isNaN(this.inputZone.nativeElement.value)){
      this.openSnackBar('El formato de la zona es incorrecto!', 'Error');
      return;
    }
    
    this.isLoadingResults = true;
    this.cdr.detectChanges();

    const updateDto: any = {};

    updateDto.UserId = this.data.userId;

    if (this.inputZone && this.inputZone.nativeElement.value) {
      updateDto.newAssignedGeoZoneLevelId = this.inputZone.nativeElement.value;
    }
    else{ 
      this.openSnackBar('Ingrese la nueva zona!', 'Error');
      this.isLoadingResults = false;
      this.cdr.detectChanges(); 
      return;
    }

    this.userService.updateCrmUser(updateDto).subscribe(x => {
      this.openSnackBar('Se actualizó la zona correctamente!', 'Ok');
      this.isLoadingResults = false;
      this.cdr.detectChanges(); 
      this.dialogRef.close(updateDto.newAssignedGeoZoneLevelId);
    },
    error => { 
        if(error.status === 404){
          this.openSnackBar('La zona ingresada no existe!', 'Error');
        } 
        else{
          this.openSnackBar('Error al actualizar la zona!', 'Error');
        }
        this.isLoadingResults = false;
        this.cdr.detectChanges(); 
    })
  }
}



export interface UserGeoZoneData{
	userId: string;
	geoZone: number;
}